module.exports = __webpack_public_path__ + "static/animation-aviva-f76dde505a213fd34e41ff8f15dcb8e1.mp4";